import * as userActions from '../user/actions';
import * as lawsProjectsActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsProjectsReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsProjectsActions.SET_LAWS_PROJECTS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsProjectsActions.SET_LAWS_PROJECTS_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsProjectsActions.SET_LAWS_PROJECTS:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsProjectsActions.ABORT_PROJECTS_REQUEST:
            return initialState;

        case lawsProjectsActions.CLEAN_LAWS_PROJECTS:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsProjects/reducer.js